// extracted by mini-css-extract-plugin
export default {"savedCard":"U_oMtaq4Decgwy90gvRz"};